import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import LogoPoweredBy from '../../../../../../../components/global/LogoPoweredBy';
import getConfig from '../../../../../../../util/config';

const propTypes = {
  className: PropTypes.string,
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const OnboardingLayoutHeader = ({ className, albumFolder }) => {
  const classes = classNames({
    'onboarding-layout-header': true,
    [className]: !!className,
  });
  const config = getConfig();

  const accountLogo = albumFolder.account?.logo_image;

  return (
    <div className={classes}>
      <div className="onboarding-layout-header-user-logo">
        {accountLogo ? (
          <img src={accountLogo.url} alt="" />
        ) : (
          <div className="onboarding-layout-header-waldo-logo" alt="" />
        )}
      </div>

      {accountLogo && (
        <a
          href={config.marcomUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="onboarding-layout-header-powered-by-logo"
        >
          <LogoPoweredBy />
        </a>
      )}
    </div>
  );
};

OnboardingLayoutHeader.propTypes = propTypes;

export default OnboardingLayoutHeader;
